if (typeof window === "undefined") {
  throw new Error("[TalkJS] The TalkJS JavaScript SDK only works in browsers (and not, for example, in Node.js)");
} // Snippet[starts]


(function (t, a, l, k, j, s) {
  s = a.createElement('script');
  s.async = 1;
  s.src = "https://cdn.talkjs.com/talk.js";
  a.head.appendChild(s);
  k = t.Promise;
  t.Talk = {
    v: 1,
    ready: {
      then: function then(f) {
        if (k) return new k(function (r, e) {
          l.push([f, r, e]);
        });
        l.push([f]);
      },
      catch: function _catch() {
        return k && new k();
      },
      c: l
    }
  };
})(window, document, []); // Snippet[ends]


module.exports = window.Talk;